/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
export default {
  badge (state) {
    return state.items.reduce((sum, item) => sum + item.qty, 0)
  },
  items (state) {
    return state.items || []
  },
  totalSegments (state) {
    const excluded = ['amasty_checkout', 'tax']
    if (state.total && state.total.total_segments) {
      return state.total.total_segments.filter(item => (excluded).indexOf(item.code) === -1)
    } else {
      return []
    }
  },
  paymentMethods (state) {
    return state.total.paymentMethods || []
  },
  totalAmount (state) {
    return Object.keys(state.total).length ? state.total.base_grand_total : 0
  },
  isEmptyCart (state) {
    return state.items.length === 0
  },
  coupon (state) {
    return state.total && state.total.coupon_code ? state.total.coupon_code : ''
  }
}
